import { render, staticRenderFns } from "./MobileDropdown.vue?vue&type=template&id=b543aca4&scoped=true"
import script from "./MobileDropdown.vue?vue&type=script&lang=js"
export * from "./MobileDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b543aca4",
  null
  
)

export default component.exports